import { numFormat } from "./index.js";

export const typeOffer = [
    {
        name: "zsjList",
        type: "2",
        label: "珠三角",
        OfferValue: "OfferValue",
        RetrieveValue: "RetrieveValue",
        classColor: "ZSJClassColor",
        list: [],
    },
    // {
    //     name: "dhqList",
    //     type: "6",
    //     label: "大数据",
    //     OfferValue: "OfferValue",
    //     RetrieveValue: "RetrieveValue",
    //     classColor: "DHQClassColor",
    //     list: [],
    // },
    {
        name: "lsList",
        type: "1",
        label: "六·三",
        OfferValue: "OfferValue",
        RetrieveValue: "RetrieveValue",
        classColor: "ClassColor",
        list: [],
    },
    {
        name: "szList",
        type: "3",
        label: "深圳A",
        OfferValue: "OfferValue",
        RetrieveValue: "RetrieveValue",
        classColor: "SZClassColor",
        list: [],
    },
    {
        name: "sz2List",
        type: "4",
        label: "深圳B",
        OfferValue: "OfferValue",
        RetrieveValue: "RetrieveValue",
        classColor: "SZ2ClassColor",
        list: [],
    },
    {
        name: "hnList",
        type: "5",
        label: "湖南",
        OfferValue: "OfferValue",
        RetrieveValue: "RetrieveValue",
        classColor: "HNClassColor",
        list: [],
    },
];

// 判断涨跌
const riseAndFall = (newV, oldV) => {
    const num = newV - oldV;

    if (num > 0) {
        return "red";
    } else if (num === 0) {
        return "";
    } else {
        return "green";
    }
};

export const addClassName = (list, type) => {
    if (type == 0) {
        type = 1;
    }
    const editList = [];

    const typeObj = typeOffer.filter((item) => {
        return item.type == type;
    })[0];

    let OfferValue = typeObj.OfferValue;
    let RetrieveValue = typeObj.RetrieveValue;

    list.forEach((item) => {
        const value = item[OfferValue] || 0;
        const retrieveValue = item[RetrieveValue] || 0;

        const classColor = riseAndFall(value, retrieveValue);
        const changeValue1 = numFormat(value - retrieveValue);

        item.classColor = classColor;
        item.value = value;
        item.changeValue1 = changeValue1 - 0;

        if (item.value) {
            editList.push({
                ...item,
            });
        }
    });

    return editList.filter((item) => {
        return item.value != 0;
    });
};

export default {
    typeOffer,
    addClassName,
};
